import React, {useCallback, useEffect, useRef, useState} from 'react';

import '../css/reset.css';
import './_Index.scss';
//import styles from './_Index.style';

import {
    Form as NForm, Popover, Button, Modal, message, Upload,
    Input, Select, Space, Tabs, Tooltip, Steps, DatePicker, TimePicker
} from 'antd';

import {ApiService} from "../_/ApiService";
import {Static} from "../_/Static";
import {StaticEvent} from "../_/StaticEvent";
import _ from "../_";

import {Link} from 'react-router-dom';


import {
    useParams,
    useNavigate
} from "react-router-dom";
import {PageDataManager} from "../hooks/UsePageDataManager";

import {Field, Form} from "react-final-form";
import {SessionManager} from "../hooks/UseSessionManager";
import {NavigateFunction} from "react-router";

import {
    LoadingOutlined,
    LockOutlined,
    PlusOutlined,
    RedoOutlined,
    CloseOutlined,
    UploadOutlined,
    LeftOutlined,
    RightOutlined
} from "@ant-design/icons";
import {lastValueFrom} from "rxjs";
import UseLoadingManager from "../hooks/UseLoadingManager";

import Partial_addOwnerProxy from "./Partial_addOwnerProxy";
import Partial_Search_Or from "./Partial_Search_Or";
import Partial_ScheduleTable from "./Partial_ScheduleTable";
import Partial_Search_TimeRangeDoctorFilter from "./Partial_Search_TimeRangeDoctorFilter";

import Partial_Appointment__Pane_AddReservation from "./Partial_Appointment__Pane_AddReservation";

import moment from 'moment';


type ViewModelProps = {
    refModal: any,

    寵物_飼主__關係No: any,
};
type Props = {
    PrefixTarget?: string;
    pageDataManager: PageDataManager
    sessionManager: SessionManager,
    navigate: NavigateFunction,

    viewModel: ViewModelProps,
};
export default function Partial_Appointment__Modal_AddReservation(props: Props) {
    let PrefixTarget: string = props.PrefixTarget || 'Partial_Appointment__Modal_AddReservation';
    let pageDataManager: PageDataManager = props.pageDataManager;
    let sessionManager: SessionManager = props.sessionManager;
    let navigate: NavigateFunction = props.navigate;

    //const [viewModel, setViewModel] = useState<ViewModelProps>(props.viewModel);
    const viewModel: any = props.viewModel;


    //#region ForceRender Control
    const [, setForceRender] = useState(false);
    const forceRender = () => {
        setForceRender(s => !s);
    };
    //#endregion

    const loadingManager = UseLoadingManager({shouldReRenderOnLoading: false});

    //#region Boot
    const _doLoadPartialData = async (): Promise<void> => {
        if (!pageDataManager.refPageData.current.Root) {
            return;
        }

        /// do not dynamically load data if condition fits.
        if (pageDataManager.isZoneExist(PrefixTarget)) {
            return;
        }
        //await _loadPageData();
    }
    useEffect(() => {
        _doLoadPartialData();
    }, []);
    //#endregion

    //#region Set Body
    const handleClose = (e) => {
        if (e) {
            e.preventDefault();
        }

        if (viewModel.refModal || viewModel.refModal.current) {
            viewModel.refModal.current.destroy();
        }
    };
    const Body = () => {
        return (
            <div className="model_wrapper">
                <div className="modal_title">
                    <div className="title_info">
                        <h2>預約</h2>
                    </div>
                    <div className="info_bar"></div>
                    <div className="control_bar">
                        <Tooltip placement="top" title={'關閉'}>
                            <Button type="text" icon={<CloseOutlined/>} onClick={handleClose}/>
                        </Tooltip>
                    </div>
                </div>
                <div className="modal_content">
                    <div className="content_box">
                        <div className="reservationbox">
                            {/*<div className="col s3_2">*/}
                            {/*    <div className="schedule">*/}
                            {/*        <Partial_Search_TimeRangeDoctorFilter*/}
                            {/*            PrefixTarget={'Partial_Reservation__Pane_ReservationUncheckedList'}*/}
                            {/*            pageDataManager={pageDataManager}*/}
                            {/*            sessionManager={sessionManager}*/}
                            {/*            navigate={navigate}*/}

                            {/*            viewModel={{*/}
                            {/*                refModal: null,*/}
                            {/*            }}*/}
                            {/*        />*/}
                            {/*        <Partial_ScheduleTable*/}
                            {/*            PrefixTarget={'Partial_ScheduleTable'}*/}
                            {/*            pageDataManager={pageDataManager}*/}
                            {/*            sessionManager={sessionManager}*/}
                            {/*            navigate={navigate}*/}

                            {/*            viewModel={{*/}
                            {/*                refModal: null,*/}
                            {/*            }}*/}
                            {/*        />*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            <div className="col rs_form">
                                <Partial_Appointment__Pane_AddReservation
                                    PrefixTarget={`Partial_Appointment__Pane_AddReservation${viewModel.寵物_飼主__關係No}`}
                                    pageDataManager={pageDataManager}
                                    sessionManager={sessionManager}
                                    navigate={navigate}

                                    viewModel={{
                                        refModal: viewModel.refModal,

                                        寵物_飼主__關係No: viewModel.寵物_飼主__關係No ?? null,
                                    }}
                                />

                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal_footer"></div>
            </div>
        );
    };
    //#endregion

    //#region Render
    return <React.Fragment>
        {Body()}
    </React.Fragment>;
    //#endregion
}
Partial_Appointment__Modal_AddReservation.displayName = 'Partial_Appointment__Modal_AddReservation';
